import {btn_md, btn_c_lightGreen, panel, clearfix, absCenterY, colors} from '@xpertdox_js/xdstyle';

export default {
    container: {
        background: '#fff',
        minHeight: '100%',
    },
    editPanel: {
        padding: 0,
        width: '100%',
        minHeight: '100%',
        fontSize: '1.2rem',
    },
    imageDisplay: {
      padding: 8,
      maxHeight: 215,
      position: 'relative',
      width: '25%',
      display: 'inline-block',
      verticalAlign: 'top'
    },
    flyerDeleteBtn: {
      display: 'inline-block',
      position: 'absolute',
      top: 0,
      right: 0,
      height: 20,
      border: 'medium none',
      padding: '0.5rem 0.9rem',
      textAlign: 'center',
      color: 'rgb(230, 39, 18)',
      background: 'rgb(255, 238, 236) none repeat scroll 0% 0%',
      cursor: 'pointer',
      outline: 'currentcolor none medium',
      fill: 'rgb(230, 39, 18)',
      stroke: 'rgb(230, 39, 18)',
      fontWeight: 'bold',
      fontSize: '1.16rem',
      borderRadius: '10rem',
      marginRight: '0.4rem',
    },
    saveBtn: {
      fontWeight: 'bold',
      ...btn_md,
      ...btn_c_lightGreen.base,
      borderRadius: '200px',
      marginTop: '8px',
      minWidth: '132px'
    },
    saveBtnHov: {
      ...btn_c_lightGreen.hover,
    }
}
